var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 235 234",
    xmlns: "http://www.w3.org/2000/svg",
    className: "rainbow-logo",
    preserveAspectRatio: "xMinYMin meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#88AEDC",
    d: "m234.04 175.67-75.69 58.28h47.18L234.04 212z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.04 140.06-121.93 93.89h.02l121.91-93.87zM133.25.95.04 103.51v.02L133.27.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F58F8E",
    fillRule: "nonzero",
    d: "M.04.95v30.16L39.21.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEE18A",
    fillRule: "nonzero",
    d: "M39.21.95.04 31.11v35.9L85.84.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F095",
    fillRule: "nonzero",
    d: "M85.84.95.04 67.01v36.5L133.25.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55C1AE",
    fillRule: "nonzero",
    d: "M133.27.95.04 103.53v35.59L179.49.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7B3CE",
    fillRule: "nonzero",
    d: "M234.04.95h-7.37L.04 175.45v35.93l234-180.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#88AEDC",
    fillRule: "nonzero",
    d: "M179.49.95.04 139.12v36.33L226.67.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F58F8E",
    fillRule: "nonzero",
    d: "M234.04 31.2.04 211.38v22.57h18.03l215.97-166.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEE18A",
    fillRule: "nonzero",
    d: "M234.04 67.65 18.07 233.95H64.7l169.34-130.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F095",
    fillRule: "nonzero",
    d: "M234.04 103.56 64.7 233.95h47.41l121.93-93.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55C1AE",
    fillRule: "nonzero",
    d: "m234.04 140.08-121.91 93.87h46.22l75.69-58.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7B3CE",
    fillRule: "nonzero",
    d: "m234.04 212-28.51 21.95h28.51z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.2372 77.75c4.5139.95 7.774 2.8 11.1343 6.3 3.0595 3.2 4.9653 6.85 5.7678 10.95.652 3.45.652 40.55 0 44.05-1.7052 9.1-9.4792 16.2-19.109 17.45-2.0062.25-8.7269.5-14.8458.5H37V77h12.4384c8.8272 0 13.3412.2 15.7988.75ZM51.5449 117v25.6l5.166-.2c4.4637-.15 5.4167-.35 7.4228-1.5 3.9121-2.3 3.9623-2.45 3.9623-24.2 0-21.2 0-21.2-3.6613-23.6-1.8056-1.2-2.558-1.35-7.473-1.55l-5.4168-.15V117ZM130.7895 84.25v7.25h-25.579v18h15.548V124h-15.548l.1003 9.1.1505 9.15 12.6892.15 12.639.1V157h-14.7957c-16.4508 0-19.0087-.3-21.6167-2.6-3.6613-3.2-3.4607-1.15-3.6112-36.3-.1003-21.9.0502-32.25.4013-33.65.7021-2.6 3.6613-5.8 6.2693-6.7 1.5548-.55 5.467-.7 17.7047-.75h15.6483v7.25ZM162.4372 105.1c3.7114 14.25 6.821 25.6 6.9213 25.25.1505-.35 3.3102-12.4 7.0718-26.85l6.8712-26.25 7.8242-.15c5.9183-.1 7.8743.05 7.8743.5s-17.3536 66.2-18.3567 69.5c-.7021 2.3-4.4637 7-6.5702 8.25-2.6582 1.5-6.5703 1.75-8.9777.5-2.1567-1.1-5.0155-4.4-6.47-7.5-.9028-1.9-15.6483-56-19.0588-70l-.3511-1.35h7.8241c7.6737 0 7.8743 0 8.2756 1.1.2006.65 3.4105 12.8 7.122 27Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevto);
export default __webpack_public_path__ + "static/media/devto.7d2e3e79b020c87e25aee7080b22dc00.svg";
export { ForwardRef as ReactComponent };